module.exports = __webpack_public_path__ + "img/nav.f6e64d94.png";